import { render, staticRenderFns } from "./GreetLogo.vue?vue&type=template&id=595d4b6b"
import script from "./GreetLogo.vue?vue&type=script&lang=js"
export * from "./GreetLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports